/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "slide": {
    "caption_colors_default": "text-black",
    "caption_size_default": "text-body-md mt-2 md:mt-3"
  },
  "swiper": {
    "arrow_colors_default": "text-gray-600",
    "navigation_item_colors_default": "bg-primary-600 data-[active=true]:bg-primary-200",
    "title_colors_default": "text-dodger-blue-800",
    "title_size_default": "text-special-headline-sm md:text-special-headline-lg pb-3 md:pb-6",
    "title_variant_default": "text-center",
    "navigation_variant_default": "hidden"
  },
  "colors_default": "bg-dodger-blue-300 wings-dodger-blue-300",
  "size_default": "py-3 md:py-6 w-screen -ml-[calc(50vw-50%)] md:w-full md:ml-0",
  "variant_default": "relative wings"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "BlogSlider");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;